<template>
  <base-modal modal-content-class="rest confirm_purch">
    <div class="content">
      <h1>{{ $_getTranslations.home_modals_resubscribe_error_modal_title }}</h1>

      <p class="mt-40">{{ $_getTranslations.home_modals_resubscribe_error_modal_not_successful }}</p>

      <p>{{ $_getTranslations.home_modals_resubscribe_error_modal_description }}</p>

      <base-button button-class="fancy_btn close_modal">
        {{ $_getTranslations.home_modals_resubscribe_error_modal_try_again_button }}
      </base-button>
    </div>
  </base-modal>
</template>

<script>
import BaseModal from '../../common/modal/BaseModal'
import BaseButton from '../../common/button/BaseButton'
import translationMixin from '../../../common/mixins/translation'

export default {
  name: 'ResubscribeError',
  components: {
    BaseModal,
    BaseButton
  },
  mixins: [translationMixin]
}
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ResubscribeError.vue